module.exports = __webpack_public_path__ + "img/船舶行业结构示意图.39fa2ebb.jpg";